export default [
  {
    "question": "Is WhatsApp Aero free?",
    "answer": "Yes. WhatsApp Aero can generally be downloaded and used without payment."
  },
  {
    "question": "Can I use WhatsApp Aero and WhatsApp together?",
    "answer": "Yes. Many users install both apps using different phone numbers."
  },
  {
    "question": "Will I lose my chats when installing WhatsApp Aero?",
    "answer": "Not if you create and restore a backup properly."
  },
  {
    "question": "Does WhatsApp Aero require root access?",
    "answer": "No. Most versions work without rooting for Android devices."
  },
  {
    "question": "Can WhatsApp Aero be banned?",
    "answer": "Using modified applications may involve risks. Users should stay updated and follow recommended usage practices."
  },
  {
    "question": "How often is WhatsApp Aero updated?",
    "answer": "Update schedules vary depending on development releases."
  },
  {
    "question": "Does WhatsApp Aero support Android 15?",
    "answer": "Most recent versions aim to support newer Android releases, including Android 15."
  },
  {
    "question": "How do I restore messages?",
    "answer": "Create a backup before installation and restore it during setup."
  },
  {
    "question": "Is WhatsApp Aero better than official WhatsApp?",
    "answer": "It depends on your needs. Users who value customization and privacy often prefer WhatsApp Aero."
  },
  {
    "question": "Where can I learn more about WhatsApp Aero?",
    "answer": "Explore our download guides, feature tutorials, update articles, comparisons, and FAQs throughout this website."
  }
];
